import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest, HttpEvent, HttpResponse, HttpEventType} from '@angular/common/http';
import { ComponentDataService } from '../component-data.service'
import { PostService } from '../post.service'
import { Post } from '../post'
import { LoginService } from '../login.service'
import * as globals from '../globals';


@Component({
  selector: 'article1',
  templateUrl: './article1.component.html',
  styleUrls: ['./article1.component.css'],
})


export class Article1Component implements OnInit {
  @Input() id:number = 0;
  @Input() parentPost:Post;
  @Output() remove = new EventEmitter<Number>();
  screenWidth = 0;
  screenHeight = 0;
  @HostListener('window:resize', ['$event'])
    onResize(event?) {
      this.screenHeight = window.innerHeight;
      this.screenWidth = window.innerWidth;
  }
  data:any = {id:0,title:"Digite o titulo", imgs:[],text:"Digite aqui o texto. Abaixo você pode selecionar fotos, ou então poderá deixar inalterado para não adicionar fotos." , two_columns:true}
  readers = []
  folderUrl = globals.URL+"/backend/uploads/"
  percentSend = 0
  saving = false
  deleting = false
  constructor(private componentDataService: ComponentDataService, private postService:PostService, public loginService: LoginService) { this.onResize() }

  ngOnInit() {
    this.parentPost.component = this
    if(this.id>0)
  	  this.getArticle1Data(this.id)
  }
  log(msg:any){
    console.log(msg)
  }
  nextImage(){
    if(this.data.imgs.length>1){
      let first = this.data.imgs[0]
      for(let i = 0; i < this.data.imgs.length-1; i++){
        this.data.imgs[i] = this.data.imgs[i+1]
      }
      this.data.imgs[this.data.imgs.length-1] = first
    }
  }
  prevImage(){
    if(this.data.imgs.length>1){
      let last = this.data.imgs[this.data.imgs.length-1]
      for(let i = this.data.imgs.length-1; i > 0; i--){
        this.data.imgs[i] = this.data.imgs[i-1]
      }
      this.data.imgs[0] = last
    }
  }
  getArticle1Data(id:number){
  	this.componentDataService.getArticle1Data(id).subscribe((article1Data) => {this.data = article1Data;this.data.imgs = article1Data.serverImgs;this.data.two_columns = article1Data.two_columns=='1'?true:false;console.log(article1Data)})
    //this.componentDataService.getArticle1Data(id).subscribe((article1Data) => {this.data.imgs = article1Data.imgs})
  }
  savePostData(){
    console.log("sending data...")
    this.saving = true
    this.postService.savePost(this.parentPost).subscribe(
        (data) => {this.saveArticle1Data(data.post_id);console.log(data)},
        error => console.log(error)
    )
  }
  deletePostData(){
    if(confirm("Excluir?")){
      console.log("Deletando post...")
      this.deleting = true
      this.postService.deletePost(this.id).subscribe((data) => {console.log(data);this.remove.emit(this.id);this.deleting=false})
    }
  }
  saveArticle1Data(post_id:number){
    this.parentPost.id = post_id
    this.id = post_id
    this.data.id = post_id
    this.componentDataService.saveArticle1Data(this.data).subscribe(
        event => {
          if (event.type == HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * event.loaded / event.total);
            this.percentSend = percentDone;
            console.log(`File is ${percentDone}% loaded.`);
          } else if (event instanceof HttpResponse) {
            console.log('File is completely loaded!');
            alert("Postagem salva!")
            this.data.fileList = []
            this.saving = false
            this.parentPost.editing = false
          }
        },
        (err) => {
          console.log("Upload Error:", err);
        }, () => {
          console.log("Upload done");
        }
    )
  }
  fileChange(event, teste) {
    console.log(this.data.title+" when changed "+teste)
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
        let file: File = fileList[0];
        this.data.fileList = fileList
        this.data.localImgs = []

        
        for (let i = 0; i < this.data.fileList.length; i++) {
            this.readers[i] = new FileReader();

            this.readers[i].onload = (event: ProgressEvent) => {
              this.data.localImgs[i] = (<FileReader>event.target).result;
              this.data.imgs = this.data.localImgs
              //console.log(this.data.localImgs[i])
              //console.log(this.data.title+ " when readed")
            }
            this.readers[i].readAsDataURL(this.data.fileList[i]); 
        }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/article1/article1.component.ts